import React from 'react';

import { graphql, useFragment } from 'react-relay';

import type { threadBody_AtlassianSearchPage$key } from './__generated__/threadBody_AtlassianSearchPage.graphql';
import { ThreadMessage } from './thread-message';

type ThreadBodyProps = {
	node: threadBody_AtlassianSearchPage$key;
	showParent?: boolean;
	maxComments?: number;
};

export const ThreadBody = ({ node, showParent = true, maxComments = 2 }: ThreadBodyProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment threadBody_AtlassianSearchPage on SearchResultGraphDocument {
				...threadMessage_AtlassianSearchPage
				integrationId
				linkedEntities {
					id
					...threadMessage_AtlassianSearchPage
				}
			}
		`,
		node,
	);

	return (
		<>
			{showParent && <ThreadMessage parent={null} node={data} />}
			{data.linkedEntities?.slice(0, maxComments).map((linkedMessage) => (
				<ThreadMessage
					key={linkedMessage.id}
					node={linkedMessage}
					parent={{ integrationId: data.integrationId }}
				/>
			))}
		</>
	);
};
